import { gql, useQuery } from "@apollo/client";
import React, { useState } from "react";
import { Helmet } from "react-helmet-async";
import { useForm } from "react-hook-form";
import { Link, useHistory } from "react-router-dom";
import { Button } from "../../components/button";
import { Podcast } from "../../components/podcast";
import { SmallButton } from "../../components/small-button";
import { CATEGORY_FRAGMENT, EPISODE_FRAGMENT, PODCAST_FRAGMENT, REVIEW_FRAGMENT } from "../../fragments";
import { podcastsPageQuery } from "../../__generated__/podcastsPageQuery";

const PODCASTS_QUERY = gql`
  query podcastsPageQuery {
    getAllPodcasts {
      ok
      error
      podcasts {
        ...PodcastParts
        category {
        ...CategoryParts
        }
        episodes {
        ...EpisodeParts
        }
        reviews {
        ...ReviewParts
        }
      }
    }
  }
  
  ${PODCAST_FRAGMENT}
  ${CATEGORY_FRAGMENT}
  ${EPISODE_FRAGMENT}
  ${REVIEW_FRAGMENT}
`;


interface IFormProps {
    searchTerm: string;
}

export const Podcasts = () => {
    const { data, loading } = useQuery<
        podcastsPageQuery
    >(PODCASTS_QUERY, {
        variables: {
        },
    });

    const { register, handleSubmit, getValues } = useForm<IFormProps>();
    const history = useHistory();
    const onSearchSubmit = () => {
        const { searchTerm } = getValues();
        history.push({
            pathname: "/search",
            search: `?term=${searchTerm}`,
        });
    };

    return (
        <div>
            <Helmet>
                <title>Podcasts | KUDOK</title>
            </Helmet>
            <div className="max-w-screen-2xl mx-auto flex flex-col pb-44">
                <form
                    onSubmit={handleSubmit(onSearchSubmit)}
                    className="bg-purple-500 w-full py-2 flex text-black"
                >
                    <input
                        {...register("searchTerm", {
                            required: true,
                            min: 3,
                        })}
                        name="searchTerm"
                        type="Search"
                        className="focus:outline-none focus:border-gray-500 p-1 ml-3 border-2 text-lg border-gray-200 transition-colors rounded-md border-0 w-3/4 md:w-3/12"
                        placeholder="Search podcasts..."
                    />
                </form>
                <div className="self-end mr-5 mt-5">
                    <Button actionText="Categories" onClick={() => { history.push("/categories") }}></Button>
                    <Button actionText="Subscriptions" onClick={() => { history.push("/subscription") }} style="ml-5"></Button>
                </div>
                <div className="pl-10">
                    <h2 className="text-4xl font-medium mb-10 pt-12 ">Feed</h2>
                    {!loading && (
                        <div className="grid mt-16 md:grid-cols-3 gap-x-5 gap-y-10">
                            {data?.getAllPodcasts.podcasts.map((podcast) => (
                                <Podcast
                                    key={Math.random() + podcast.id}
                                    id={podcast.id + ""}
                                    coverImage={podcast.coverImg}
                                    title={podcast.title}
                                    category={podcast.category?.name}
                                    rating={podcast.rating}
                                    createdAt={podcast.createdAt}
                                />
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};